import { Box,  Card, CardContent, Stack } from "@mui/material";
import { useFormContext  } from "react-hook-form";
import { PollingFrequencyForm, PollingFrequencyFormObject } from "../PollingFrequencyUtils";
import { eLynxObjectTypeEnum } from "../../../common/enums/eLynxObjectType";
import FormCheckbox from "../../../components/forms/form-checkbox/FormCheckbox";

export type PollingFrequencyObjectListItemProps = {
    item: PollingFrequencyFormObject,
    onSelected: (item: PollingFrequencyFormObject, value: boolean) => void;
}

export function PollingFrequencyObjectListItem({
    item,
    onSelected
}: PollingFrequencyObjectListItemProps) {

    const name = item.objectType === eLynxObjectTypeEnum.Device ? 
                    'devices' :
                    item.objectType === eLynxObjectTypeEnum.Tank ? 
                    'tanks' :
                    'tats';

    const {
        watch,
    } = useFormContext<PollingFrequencyForm>();    
    
    const [watchItems] = watch([name]);

    // we need the 'real' index of the item
    //const index = watchItems.findIndex(o => o.id  === item.id);
    const index = watchItems.findIndex(o => o.label  === item.label);
                        
    function renderRecipient() {

            return (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        flex: '1 1 auto'
                    }}>
                    <FormCheckbox
                        name={`${name}.${index}.selected`}
                        label={<Stack direction='row'> {item.label}</Stack>}
                        sx={{ 
                            marginRight: 0,
                            marginTop: 0,
                        }}
                        typographyProps={{
                            sx: {
                                fontSize: '.95rem',
                            }
                        }}
                        onChange={(_event, checked) => onSelected(item, checked)}

                        />
                </Box>
            );
    }

    return (
        <Card variant="outlined">
            <CardContent sx={{
                padding: (theme) => `0 ${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(1)} !important`,
            }}>
                { renderRecipient() }
            </CardContent>
        </Card>
    );
}
